import { Entity } from '@api';
import {
  SkeletonLoader,
  SkeletonLoaderArea,
} from '@design/components/skeleton-loader/SkeletonLoader';
import { usePriceMarketReactionData } from '@terminal/hooks/use-price-market-reaction-data/usePriceMarketReactionData';
import { CatalystMarketReactionChart } from '@terminal/modules/market-reaction-charts/catalyst-market-reaction-chart/CatalystMarketReactionChart';
import React from 'react';

import styles from './CompanyCatalystReaction.module.scss';

export interface CompanyCatalystReactionProps {
  entityTag: string;
  entity?: Entity;
  reportingDate: string;
  isMultipleEntitiesChart?: boolean;
  leftHeaderNode?: React.ReactNode;
}

export const CompanyCatalystReaction = ({
  entityTag,
  entity,
  reportingDate,
  isMultipleEntitiesChart = false,
  leftHeaderNode,
}: CompanyCatalystReactionProps) => {
  const {
    priceData,
    fromDateEST,
    toDateEST,
    lastProportionChange,
    lastKnownPrice,
    prevCloseData,
    lastKnownDate,
    isLoading,
  } = usePriceMarketReactionData({
    entityTag,
    ticker: entity?.subscribable_ticker ?? '',
    reportingDate,
    isMultipleEntitiesChart,
    variant: 'catalyst',
  });

  if (isLoading) {
    const skeletonLoaderAreas: SkeletonLoaderArea[] = [
      {
        styles: {
          width: '100%',
          height: '400px',
          borderRadius: '8px',
        },
      },
    ];

    return (
      <div className={styles.skeletonLoaderWrapper}>
        <SkeletonLoader areas={skeletonLoaderAreas} />
      </div>
    );
  }

  return (
    <CatalystMarketReactionChart
      fromDateEST={fromDateEST}
      toDateEST={toDateEST}
      lines={
        priceData
          ? [
              {
                data: priceData,
                prevCloseData,
                lastProportionChange,
                lastKnownPrice,
                lastKnownDate,
              },
            ]
          : []
      }
      entities={entity ? [entity] : undefined}
      leftHeaderNode={leftHeaderNode}
    />
  );
};
